import React from 'react';
import styled from 'styled-components';
import { RemoveIcon } from '../Icons';
import { string } from 'prop-types';
import { OnPrimary } from '../../Colors';

const Button = styled.button`
    text-decoration: none;
    border: 0;
    text-transform: none;
    background-color : transparent;
    &:focus{
        border: 0;
        outline: 0;
    }
`;

const Icon = styled(RemoveIcon)`
    color : ${props => props.color ?  props.color : OnPrimary};
    &:hover{
        color : black;
    }
`;

const CloseButton = ({color,...props}) => (
	<Button {...props}>
		<Icon color={color}></Icon>
	</Button>);

CloseButton.propTypes = {
	color: string,
};


export default CloseButton;